import './SidebarContact.scss'

import {Background} from '@codeurs/front'
import React from 'react'
import {ImageType, LinkType, WysiwygType} from '../../types'
import {Link} from '../../util/link'
import {style} from '../../util/style'
import {Block} from '../blocks/Blocks'
import {Theme} from '../Theme'

const styles = style('sidebarcontact')

export type SidebarContactType = {
	image?: ImageType
	text: WysiwygType
	phone?: string
	button: LinkType
}

export const SidebarContact: React.FC<SidebarContactType> = ({
	image,
	text,
	phone,
	button
}) => {
	if (!image && !text && !button) return null

	return (
		<Block className={styles()} sidebar={true}>
			{image && image.src && (
				<div className={styles('image')}>
					<Background img={image} className={styles('image-bg').toString()} />
				</div>
			)}
			{(text || phone) && (
				<div className={styles('content')}>
					{text && (
						<div className={styles('content-text')}>
							<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
						</div>
					)}
					{phone && (
						<Theme.H3 className={styles('content-phone')}>{phone}</Theme.H3>
					)}
				</div>
			)}
			{button && button.url && (
				<Link to={button.url} className={styles('button')}>
					{button.description || button.title}
				</Link>
			)}
		</Block>
	)
}
